import WarpElement from "@warp-ds/elements-core";
import { CategoryWithLink } from "../../models/category.js";
import { css, html } from "lit";
import { largeNumberFormatter } from "../../utils/formatters.js";
import { Brand, Subvertical } from "../../constants.js";
import { trackClickEvent } from "../tracking.js";
import { TrackingEventMap } from "../../models/trackingEvent.js";
import { getLocaleByBrand } from "../../utils/getLocaleByBrand.js";
import "@warp-ds/elements/components/card";

class Categories extends WarpElement {
    declare categories: Array<CategoryWithLink>;
    declare subvertical: Subvertical;
    declare brand: Brand;
    declare trackingEventMap: TrackingEventMap;
    static properties = {
        categories: { type: Array },
        subvertical: { type: String },
        brand: { type: String },
        trackingEventMap: { type: Object },
    };

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    static styles = [
        WarpElement.styles,
        css`
            .list-wrapper {
                display: grid;
                grid-template-columns: repeat(3, 156px);
            }
            .default-layout a:hover span {
                color: var(--s-text-link);
            }

            .button-layout a:hover {
                text-decoration: none;
            }
            @css-placeholder-bGULGi;
        `,
    ];

    render() {
        return html`<div class="flex flex-col gap-y-40 -mx-16 md:-mx-10">
            <section class="w-full button-layout">
                <div class="overflow-hidden">
                    <div
                        class="grid grid-rows-2 grid-flow-col auto-cols-[minmax(40vw,1fr)] md:grid-rows-none md:grid-flow-row gap-8 md:gap-16 md:w-full overflow-x-auto px-16 pb-8 md:px-10 md:pb-0 md:grid-cols-4"
                        style="scrollbar-width: none;"
                    >
                        ${(this.categories ?? []).map(
                            (category) =>
                                html`<w-card
                                    class="h-[78px] md:h-[82px] flex flex-col overflow-hidden s-border border rounded-8"
                                    @click="${() => trackClickEvent(category.trackingEvent)}"
                                >
                                    <a
                                        class="flex flex-col justify-between p-8 relative z-10 w-full md:h-[82px] h-[78px]"
                                        href="${category.link}"
                                    >
                                        <span class="s-text font-bold text-caption">${category.title}</span>
                                        ${category.hits
                                            ? html`<span class="s-text-subtle text-caption" aria-hidden="false">
                                                  ${largeNumberFormatter(category.hits, getLocaleByBrand(this.brand))}
                                              </span>`
                                            : ""}
                                    </a>
                                </w-card>`,
                        )}
                    </div>
                </div>
            </section>
        </div>`;
    }
}

customElements.define("category-list", Categories as unknown as CustomElementConstructor);
